import axiosInstance from '../../../utils/apiClient';

const HH_API_URL = process.env.REACT_APP_HH_API;
const IMAGE_UPLOAD_TIMEOUT_MS = 15000;

export const getUserInfo = async () => {
  return axiosInstance.get('/user/userinfo');
};

export const getInstructions = async (accessKey: string | undefined) => {
  return axiosInstance.get(`/invitation/instruction?access_key=${accessKey}`);
};

export const fetchBrandDetails = async (token: string, view: string) => {
  try {
    const result = await axiosInstance.get(
      `${HH_API_URL}/user-settings/brand-details?view=${view}&token=${token}`
    );
    return result.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const authenticateUser = async (
  accessKey: string | undefined,
  name: string,
  email: string,
  startTimer: boolean
) => {
  return axiosInstance.post(
    `/invitation/confirmation?access_key=${accessKey}`,
    { name, email, start_assessment: startTimer }
  );
};

export const getAssessmentDetails = async (accessKey: string | undefined) => {
  return axiosInstance.get(`/invitation/detail?access_key=${accessKey}`);
};

export const submitPictureToAPI = async (
  accessKey: string | undefined,
  base64Image: string | null
) => {
  try {
    const response = await axiosInstance.post(
      `/invitation/uploadImage?access_key=${accessKey}`,
      { base64Image }
    );
    return response.data;
  } catch (error) {
    throw console.error('Failed to submit picture to API');
  }
};

// This is used to send proctoring images
export const proctoringImagePost = async (
  accessKey: string | undefined,
  base64Image: string | null,
  questionNo: number,
  adaptive?: boolean
) => {
  try {
    const response = await axiosInstance.post(
      `/${
        adaptive ? 'adaptive' : 'invitation'
      }/uploadImage?access_key=${accessKey}`,
      { base64Image, questionNo },
      { timeout: IMAGE_UPLOAD_TIMEOUT_MS }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to submit picture to API', error);
    throw error;
  }
};
